import assert from '../assert';
import isPlainObject from './is-plain-object';

export default entity =>
  assert(
    isPlainObject(entity),
    `
  Entity must be a plain javascript object.
  Received is ${typeof entity}.
`
  );
